var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.685 4.073c.526.417.885.964 1.01 1.544a2.21 2.21 0 0 1-.435 1.845l-7.176 9.254a1.918 1.918 0 0 1-1.497.749l-2.769.035H3.81a.65.65 0 0 1-.632-.508l-.627-2.724a1.961 1.961 0 0 1 .362-1.65l.942-1.215a.643.643 0 0 1 .911-.111.66.66 0 0 1 .11.921l-.942 1.216a.643.643 0 0 0-.118.541l.508 2.21 2.246-.028a.63.63 0 0 0 .492-.245l7.176-9.254c.183-.237.246-.49.19-.756-.062-.281-.254-.562-.544-.79l-1.203-.955c-.466-.368-1.123-.557-1.571.024l-.948 1.221 1.505 1.22a.66.66 0 0 1 .1.921.643.643 0 0 1-.912.103L9.36 6.43 6.906 9.596a.644.644 0 0 1-.912.111.662.662 0 0 1-.11-.921l4.204-5.422c.815-1.053 2.243-1.156 3.394-.245l1.203.953ZM11.33 16.187h5.52c.36 0 .65.294.65.657 0 .362-.29.656-.65.656h-5.52a.652.652 0 0 1-.649-.656c0-.363.29-.657.65-.657Z",
    fill: "#109B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6d36292ef9c964f0676f86570e305bd9.svg";
export { ForwardRef as ReactComponent };